import React, { useEffect, useState } from "react";
import { useTranslation } from "../i18n";
import AuthLanguageDropdown from "../Components/AuthLanguageDropdown";
import AuthLeftColumn from "../Components/AuthLeftColumn";

import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { vendorResetPasswordAction } from "../actions/auth";
import { toogleErrorMessage } from "../actions/alertMessage";

const ResetPassword = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => Boolean(state.auth?.vendorResetPasswordLoading),
  );
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswords, setShowPasswords] = useState(false);
  const canResetPassword = Boolean(
    token &&
    newPassword.length > 0 &&
    confirmPassword.length > 0 &&
    newPassword === confirmPassword &&
    !loading
  );

  useEffect(() => {
    if (!token) {
      toogleErrorMessage("This password reset link is invalid.");
      navigate("/forgot-password", { replace: true });
    }
  }, [navigate, token]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!newPassword || !confirmPassword) {
      toogleErrorMessage("Please enter and confirm your new password.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toogleErrorMessage("The passwords do not match.");
      return;
    }

    const result = await dispatch(
      vendorResetPasswordAction(token, { newPassword, confirmPassword }),
    );
    if (result?.success) navigate("/", { replace: true });
  };

  return (
    <main className="admin-login-page admin-login-page--reference admin-login-page--auth-shared">
      <div className="container-fluid p-0">
        <div className="row g-0 admin-login-card">
          <AuthLeftColumn />
          <div className="col-lg-6 col-md-6 col-12 admin-login-right">
            <div className="admin-login-right-inner">
              <div className="admin-login-mobile-logo d-md-none">
                <img src="/assets/lualilogoblack.svg" alt={t("ui.luali.commodities")} />
                <AuthLanguageDropdown />
              </div>
              <div className="admin-login-form-content">
                <div className="admin-login-heading">
                  <h1>{t("ui.reset.password")}</h1>
                  <p>{t("ui.enter.your.new.password.and.confirm.it.to.finish.resetting.your.account")}</p>
                </div>
                <form className="admin-login-form" onSubmit={handleSubmit} noValidate>
                  <div className="admin-login-field">
                    <label htmlFor="new-password" className="form-label">{t("ui.new.password")}</label>
                    <div className="login-input-box">
                      <input
                        id="new-password"
                        type={showPasswords ? "text" : "password"}
                        className="form-control"
                        placeholder={t("ui.enter.a.new.password")}
                        value={newPassword}
                        onChange={(event) => setNewPassword(event.target.value)}
                        autoComplete="new-password"
                        required
                      />
                    </div>
                  </div>
                  <div className="admin-login-field">
                    <label htmlFor="confirm-password" className="form-label">{t("ui.confirm.password")}</label>
                    <div className="login-input-box">
                      <input
                        id="confirm-password"
                        type={showPasswords ? "text" : "password"}
                        className="form-control"
                        placeholder={t("ui.confirm.your.new.password")}
                        value={confirmPassword}
                        onChange={(event) => setConfirmPassword(event.target.value)}
                        autoComplete="new-password"
                        required
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="reset-password-toggle"
                    aria-pressed={showPasswords}
                    onClick={() => setShowPasswords((current) => !current)}
                  >
                    {showPasswords ? t("ui.hidePasswords") : t("ui.showPasswords")}
                  </button>
                  <button
                    type="submit"
                    className="recent-view-all-btn w-100"
                    disabled={!canResetPassword}
                  >
                    {loading ? t("ui.resetting") : t("ui.resetPassword")}
                  </button>
                </form>
                <div className="admin-login-bottom-text">
                  <span>{t("ui.remember.your.password")}</span>
                  <button type="button" onClick={() => navigate("/")}>{t("ui.back.to.login")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ResetPassword;
